import React, { FunctionComponent, useEffect } from 'react';

import { MODAL } from '../../context';
import { useApp } from '../../hooks';
import Modal from '../Modal/Modal';
import { EncourageDonateModal } from './EncourageDonateModal';

export const EncourageDonateModalContainer: FunctionComponent = () => {
  const { hideModal, showModal, openModal } = useApp();
  const storageKey = 'isEncourageDonatePromptDismissed';
  const closeModal = () => {
    localStorage.setItem(storageKey, String(true));
    hideModal();
  };

  useEffect(() => {
    const userHasDismissed = localStorage.getItem(storageKey) === String(true);

    if (userHasDismissed) {
      return;
    }

    const timer = global.setTimeout(() => {
      showModal(MODAL.ENCOURAGE_DONATE);
    }, 40000);

    return () => clearTimeout(timer);
  }, [showModal]);

  return (
    <>
      {openModal === MODAL.ENCOURAGE_DONATE && (
        <Modal onCloseRequest={closeModal}>
          <EncourageDonateModal onClose={closeModal} />
        </Modal>
      )}
    </>
  );
};
